import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { RouteError } from '@/components/route-error'
import { RoutePending } from '@/components/route-pending'
import { IssuesPage } from '@/features/issues/issues-page'
import { requireAuth } from '@/lib/auth'

/* /issues — everything that needs attention at the selected store. Anyone
   signed in can see it (fixes they can't do say "ask a manager"). The tab and
   the group filter live in the URL. */
const searchSchema = z.object({
  tab: z.enum(['open', 'resolved']).optional(),
  group: z.enum(['metrc', 'payments', 'store']).optional(),
})

export const Route = createFileRoute('/_dashboard/issues')({
  beforeLoad: requireAuth(),
  validateSearch: searchSchema,
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: IssuesRoute,
})

function IssuesRoute() {
  const { tab, group } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <IssuesPage
      tab={tab ?? 'open'}
      group={group}
      onChange={(next) => navigate({ search: { tab: next.tab === 'open' ? undefined : next.tab, group: next.group }, replace: true })}
    />
  )
}
